import { APIResponse, APIResponseDtoImpl } from '../apiresponse';
import { CategoryDto } from '../../dto/categories/categorydto';

export interface SignupCategoriesResponse extends APIResponse
{
    getSignupCategoriesDtos(): CategoryDto[];
}

export class SignupCategoriesResponseDtoImpl extends APIResponseDtoImpl implements SignupCategoriesResponse
{
    private signupCategoriesDtos : CategoryDto[];

    getSignupCategoriesDtos(): CategoryDto[]
    {
        return this.signupCategoriesDtos;
    }
    setSignupCategoriesDtos(signupCategoriesDtos: CategoryDto[])
    {
        this.signupCategoriesDtos = signupCategoriesDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/signupcategories/signupcategoriesresponse.tsx